import React, { useEffect, useMemo, useRef, useState } from "react";
// NOTE: This is a single-file, production-ready UI scaffold written in TypeScript React.
// Styling is Tailwind-first and dependency-light. Icons use lucide-react (optional – see notes).
// Replace mock data handlers with your data layer (Firestore, REST, etc.).

// =============================
// Optional icon pack (lucide)
// =============================
// If you have lucide-react, uncomment the import below and set USE_LUCIDE=true.
import {
  ArrowRight, Users, PersonStanding, ClipboardList, Dumbbell,
  MessageSquare, TrendingUp, Camera, Trash2 as Trash, Save, Download,
  RotateCcw, FileScan, UserPlus, Search as SearchIcon, Filter,
  MoreHorizontal, Plus, Upload, CheckSquare
} from "lucide-react";

const USE_LUCIDE = true;

// Minimal inline SVG icons to avoid extra deps. Swap to lucide-react by toggling USE_LUCIDE.
const Svg = {
  ArrowRight: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M13 5l7 7-7 7"/></svg>
  ),
  Users: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><path strokeWidth="2" d="M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4" strokeWidth="2"/><path strokeWidth="2" d="M23 21v-2a4 4 0 0 0-3-3.87"/><path strokeWidth="2" d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
  ),
  PersonStanding: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><circle cx="12" cy="4" r="2" strokeWidth="2"/><path strokeWidth="2" d="M9 22v-6H7l3-8h4l3 8h-2v6"/></svg>
  ),
  ClipboardList: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><rect x="8" y="2" width="8" height="4" rx="1" strokeWidth="2"/><rect x="4" y="4" width="16" height="18" rx="2" strokeWidth="2"/><path strokeWidth="2" d="M9 10h6M9 14h6M9 18h6"/></svg>
  ),
  Dumbbell: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><path strokeWidth="2" d="M1 12h5M18 12h5M7 7v10M17 7v10M7 9h10M7 15h10"/></svg>
  ),
  MessageSquare: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><path strokeWidth="2" d="M21 15a4 4 0 0 1-4 4H8l-5 5V6a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"/></svg>
  ),
  TrendingUp: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><path strokeWidth="2" d="M3 17l6-6 4 4 7-7"/><path strokeWidth="2" d="M14 7h7v7"/></svg>
  ),
  Camera: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><path strokeWidth="2" d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4" strokeWidth="2"/></svg>
  ),
  Trash: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><path strokeWidth="2" d="M3 6h18M8 6V4h8v2M6 6l1 14a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-14"/></svg>
  ),
  Save: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><path strokeWidth="2" d="M19 21H5a2 2 0 0 1-2-2V7l4-4h10l4 4v12a2 2 0 0 1-2 2z"/><path strokeWidth="2" d="M17 21v-8H7v8M7 3v4h10V3"/></svg>
  ),
  Download: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><path strokeWidth="2" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path strokeWidth="2" d="M7 10l5 5 5-5M12 15V3"/></svg>
  ),
  RotateCcw: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><path strokeWidth="2" d="M3 2v6h6"/><path strokeWidth="2" d="M3.51 15a9 9 0 1 0 .49-9"/></svg>
  ),
  FileScan: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><rect x="3" y="4" width="18" height="16" rx="2" strokeWidth="2"/><path strokeWidth="2" d="M7 8h10M7 12h10M7 16h6"/></svg>
  ),
  UserPlus: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><path strokeWidth="2" d="M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4" strokeWidth="2"/><path strokeWidth="2" d="M20 8v6M17 11h6"/></svg>
  ),
  Search: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><circle cx="11" cy="11" r="7" strokeWidth="2"/><path strokeWidth="2" d="M21 21l-4.3-4.3"/></svg>
  ),
  Filter: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><path strokeWidth="2" d="M3 5h18l-7 8v6l-4-2v-4z"/></svg>
  ),
  MoreHorizontal: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><circle cx="5" cy="12" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="19" cy="12" r="1.5"/></svg>
  ),
  Plus: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><path strokeWidth="2" d="M12 5v14M5 12h14"/></svg>
  ),
  Upload: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><path strokeWidth="2" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path strokeWidth="2" d="M7 10l5-5 5 5M12 5v14"/></svg>
  ),
  CheckSquare: (p: any) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...p}><rect x="3" y="3" width="18" height="18" rx="2" strokeWidth="2"/><path strokeWidth="2" d="M9 12l2 2 4-4"/></svg>
  ),
};

const Icon = (name: keyof typeof Svg, props: any) => {
  if (USE_LUCIDE) {
    // Use lucide-react icons
    const LucideIcon = {
      ArrowRight, Users, PersonStanding, ClipboardList, Dumbbell,
      MessageSquare, TrendingUp, Camera, Trash, Save, Download,
      RotateCcw, FileScan, UserPlus, Search: SearchIcon, Filter,
      MoreHorizontal, Plus, Upload, CheckSquare
    }[name];
    return LucideIcon ? <LucideIcon {...props} /> : null;
  }
  // @ts-ignore
  return (Svg[name] as any)(props);
};

// =============================
// Design Tokens (mirrors your spec)
// =============================
const COLORS = {
  primary: "hsl(var(--primary))",
  secondaryBg: "#f8fafc",
  secondaryBorder: "#e2e8f0",
  success: "#10b981",
  warning: "#f59e0b",
  destructive: "#ef4444",
  muted: "#64748b",
  bgLight: "#ffffff",
  bgDark: "#0f172a",
  border: "#e2e8f0",
};

// =============================
// Generic UI elements
// =============================
const Card: React.FC<{ className?: string; children: React.ReactNode } & React.HTMLAttributes<HTMLDivElement>> = ({ className = "", children, ...rest }) => (
  <div className={`bg-card dark:bg-card border border-border dark:border-border rounded-lg shadow-sm ${className}`} {...rest}>
    {children}
  </div>
);

const Button: React.FC<{
  children: React.ReactNode;
  variant?: "default" | "outline" | "ghost" | "destructive";
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  title?: string;
}> = ({ children, variant = "default", className = "", onClick, disabled, title }) => {
  const base = "inline-flex items-center justify-center rounded-md h-10 px-4 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors";
  const styles = {
    default: "bg-primary hover:bg-primary/90 text-primary-foreground focus:ring-primary",
    outline: "border border-border dark:border-border bg-transparent text-foreground dark:text-foreground hover:bg-background/40",
    ghost: "text-foreground dark:text-muted-foreground hover:bg-background/50 dark:hover:bg-card",
    destructive: "bg-destructive hover:bg-destructive/90 text-destructive-foreground focus:ring-destructive",
  }[variant];
  return (
    <button aria-label={typeof children === "string" ? children : title} disabled={disabled} onClick={onClick} className={`${base} ${styles} ${disabled ? "opacity-60 cursor-not-allowed" : ""} ${className}`}>
      {children}
    </button>
  );
};

const Badge: React.FC<{ children: React.ReactNode; className?: string } & React.HTMLAttributes<HTMLSpanElement>> = ({ children, className = "", ...rest }) => (
  <span className={`inline-flex items-center px-2 py-0.5 text-xs rounded-md ${className}`} {...rest}>{children}</span>
);

const Input: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = (props) => (
  <input {...props} className={`h-12 w-full px-3 rounded-md border border-border dark:border-border bg-card dark:bg-card text-foreground dark:text-foreground placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-primary ${props.className ?? ""}`} />
);

const Textarea: React.FC<React.TextareaHTMLAttributes<HTMLTextAreaElement>> = (props) => (
  <textarea {...props} className={`w-full px-3 py-2 rounded-md border border-border dark:border-border bg-card dark:bg-card text-foreground dark:text-foreground placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-primary ${props.className ?? ""}`} />
);

const Switch: React.FC<{ checked: boolean; onChange: (v: boolean) => void; id?: string; label?: string } & React.HTMLAttributes<HTMLButtonElement>> = ({ checked, onChange, id, label, ...rest }) => (
  <button id={id} role="switch" aria-checked={checked} onClick={() => onChange(!checked)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${checked ? "bg-primary" : "bg-background"}`} {...rest}>
    <span className={`inline-block h-5 w-5 transform rounded-full bg-card transition ${checked ? "translate-x-5" : "translate-x-1"}`} />
    {label && <span className="sr-only">{label}</span>}
  </button>
);

const Divider: React.FC<{ className?: string }> = ({ className = "" }) => (
  <div className={`h-px w-full bg-background dark:bg-card ${className}`} />
);

// =============================
// App Shell
// =============================

type RouteKey = 
  | "dashboard"
  | "posture"
  | "sop"
  | "drills"
  | "chat";

const NAV: { key: RouteKey; label: string }[] = [
  { key: "dashboard", label: "Dashboard" },
  { key: "posture", label: "Posture Analysis" },
  { key: "sop", label: "SOP Assessment" },
  { key: "drills", label: "Drill Library" },
  { key: "chat", label: "Ask Harry" },
];

export default function HarryUI() {
  const [route, setRoute] = useState<RouteKey>("dashboard");
  const [client, setClient] = useState<{ id: string; name: string; heightCm?: number } | null>(null);

  return (
    <div className="min-h-screen bg-background dark:bg-card text-foreground dark:text-foreground">
      {/* Topbar */}
      <header className="sticky top-0 z-40 backdrop-blur bg-card/70 dark:bg-card/60 border-b border-border dark:border-border">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-8 w-8 rounded-md bg-primary" aria-hidden />
            <h1 className="text-lg font-bold tracking-tight">Harry – Biomechanics</h1>
          </div>
          <nav className="hidden md:flex items-center gap-1">
            {NAV.map((n) => (
              <Button key={n.key} variant={route === n.key ? "default" : "ghost"} onClick={() => setRoute(n.key)} className="h-10">
                {n.label}
              </Button>
            ))}
          </nav>
          <div className="md:hidden">
            <select aria-label="Navigate" className="h-10 rounded-md bg-card dark:bg-card border border-border dark:border-border" value={route} onChange={(e) => setRoute(e.target.value as RouteKey)}>
              {NAV.map((n) => (
                <option key={n.key} value={n.key}>{n.label}</option>
              ))}
            </select>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-6">
        {route === "dashboard" && <Dashboard client={client} setRoute={setRoute} />}
        {route === "posture" && <PostureAnalysis client={client} onPickClient={setClient} />}
        {route === "sop" && <SOPAssessment client={client} onPickClient={setClient} />}
        {route === "drills" && <DrillLibrary />}
        {route === "chat" && <AskHarry />}
      </main>
    </div>
  );
}

// =============================
// DASHBOARD (/dashboard)
// =============================
const Dashboard: React.FC<{ client: any; setRoute: (r: RouteKey) => void }> = ({ setRoute }) => {
  const userFirstName = "Michail";
  const cards = [
    {
      key: "clients",
      title: "Your Clients",
      desc: "Manage your client profiles, track their progress, and view their assessment history.",
      icon: <>{Icon("Users", { className: "h-6 w-6 text-primary" })}</>,
      cta: () => setRoute("sop"),
      ctaLabel: "Go to Clients",
    },
    {
      key: "posture",
      title: "Posture Analysis",
      desc: "AI-powered posture assessment with camera integration and real-time analysis.",
      icon: <>{Icon("PersonStanding", { className: "h-6 w-6 text-primary" })}</>,
      cta: () => setRoute("posture"),
      ctaLabel: "Start Analysis",
    },
    {
      key: "sop",
      title: "SOP Assessment",
      desc: "Standard Operating Procedure assessments with automated scoring and reporting.",
      icon: <>{Icon("ClipboardList", { className: "h-6 w-6 text-primary" })}</>,
      cta: () => setRoute("sop"),
      ctaLabel: "Start Assessment",
    },
    {
      key: "drills",
      title: "Drill Library",
      desc: "Comprehensive exercise library with filtering, search, and categorization.",
      icon: <>{Icon("Dumbbell", { className: "h-6 w-6 text-primary" })}</>,
      cta: () => setRoute("drills"),
      ctaLabel: "Browse Drills",
    },
    {
      key: "ask",
      title: "Ask Harry",
      desc: "AI chat assistant trained on all course materials for instant answers.",
      icon: <>{Icon("MessageSquare", { className: "h-6 w-6 text-primary" })}</>,
      cta: () => setRoute("chat"),
      ctaLabel: "Chat Now",
    },
    {
      key: "model",
      title: "Progression Model",
      desc: "Step-by-step movement restoration process with phase tracking and troubleshooting.",
      icon: <>{Icon("TrendingUp", { className: "h-6 w-6 text-primary" })}</>,
      cta: () => alert("Open Progression Model"),
      ctaLabel: "View Model",
    },
  ];

  return (
    <div className="space-y-8">
      <Card className="p-6">
        <h2 className="text-3xl font-bold tracking-tight">Welcome, {userFirstName}!</h2>
        <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
          I'm excited you're here. This platform is designed to give you all the tools you need to effectively apply my biomechanics methodology and get incredible results for your clients. Let's make a difference together.
        </p>
      </Card>

      <section>
        <h3 className="text-2xl font-bold tracking-tight mb-4">Getting Started</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {cards.map((c) => (
            <Card key={c.key} className="hover:shadow-md transition">
              <div className="p-6">
                <div className="flex items-center gap-2">
                  {c.icon}
                  <div className="text-xl font-semibold truncate">{c.title}</div>
                </div>
              </div>
              <div className="px-6 pb-4">
                <p className="text-sm text-muted-foreground">{c.desc}</p>
              </div>
              <div className="px-6 pb-6">
                <Button variant="outline" className="w-full sm:w-auto h-12" onClick={c.cta}>
                  <span>{c.ctaLabel}</span>
                  <span className="ml-2 inline-flex">{Icon("ArrowRight", { className: "h-4 w-4" })}</span>
                </Button>
              </div>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
};

// =============================
// POSTURE ANALYSIS (/posture-analysis)
// =============================
const PostureAnalysis: React.FC<{
  client: { id: string; name: string; heightCm?: number } | null;
  onPickClient: (c: any) => void;
}> = ({ client, onPickClient }) => {
  // Local state
  const [unitInches, setUnitInches] = useState(false);
  const [height, setHeight] = useState<number | undefined>(client?.heightCm ?? undefined);
  const [activeView, setActiveView] = useState<"Anterior" | "Right" | "Posterior" | "Left">("Anterior");
  const [images, setImages] = useState<Record<string, string | null>>({ Anterior: null, Right: null, Posterior: null, Left: null });
  const [unassigned, setUnassigned] = useState<string[]>([]);
  const [overlayLandmarks, setOverlayLandmarks] = useState(false);
  const [overlayPlumb, setOverlayPlumb] = useState(true);
  const [saving, setSaving] = useState<"idle" | "saving" | "saved">("idle");
  const [showClientDialog, setShowClientDialog] = useState(!client);
  const [showResetConfirm, setShowResetConfirm] = useState(false);

  useEffect(() => {
    if (client?.heightCm && height === undefined) setHeight(client.heightCm);
  }, [client]);

  const setHeightValidated = () => {
    if (!height || height <= 0) return alert("Enter a valid height");
    alert(`Height set: ${height} ${unitInches ? "in" : "cm"}`);
  };

  const handleCapture = async () => {
    // Mock: generate a placeholder data URL.
    const placeholder = `data:image/svg+xml;utf8,${encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'><rect width='100%' height='100%' fill='%23e2e8f0'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' font-family='Inter' font-size='16'>${activeView} Capture</text></svg>`)}`;
    setImages((prev) => ({ ...prev, [activeView]: placeholder }));
  };

  const handleDeleteView = () => {
    setImages((prev) => ({ ...prev, [activeView]: null }));
  };

  const handleSave = async () => {
    setSaving("saving");
    setTimeout(() => setSaving("saved"), 900);
    setTimeout(() => setSaving("idle"), 1600);
  };

  const handleReset = () => {
    setImages({ Anterior: null, Right: null, Posterior: null, Left: null });
    setUnassigned([]);
  };

  const heightFromProfile = client?.heightCm !== undefined;

  return (
    <div className="space-y-4">
      {/* Settings Header */}
      <Card className="shadow-md rounded-lg">
        <div className="p-6 flex flex-wrap items-center gap-4">
          <div className="flex items-center gap-2">
            <Input type="number" placeholder="Height" value={height ?? ""} onChange={(e) => setHeight(Number(e.target.value))} className="w-24" disabled={heightFromProfile} />
            <Button className="h-12 px-4" onClick={setHeightValidated} disabled={heightFromProfile}>Set</Button>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm">cm</span>
            <Switch checked={unitInches} onChange={(v) => setUnitInches(typeof v === 'boolean' ? v : unitInches)} />
            <span className="text-sm">inches</span>
          </div>
          {heightFromProfile && (
            <em className="text-sm text-muted-foreground">Client height loaded automatically.</em>
          )}
        </div>
      </Card>

      {/* Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-6">
        {/* Left: Capture */}
        <div className="flex flex-col gap-4">
          {/* View buttons */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-2">
            {["Anterior", "Right", "Posterior", "Left"].map((v) => (
              <Button key={v} variant={activeView === v ? "default" : "outline"} className="h-12" onClick={() => setActiveView(v as any)}>
                {v}
              </Button>
            ))}
          </div>

          {/* Camera feed / image */}
          <Card>
            <div className="p-4">
              <div className="w-full aspect-square rounded-md bg-background dark:bg-card relative overflow-hidden">
                {images[activeView] ? (
                  <img src={images[activeView] ?? undefined} alt={`${activeView} capture`} className="w-full h-full object-cover" />
                ) : (
                  <div className="absolute inset-0 grid place-items-center text-muted-foreground">Live camera feed here</div>
                )}
                {images[activeView] && (
                  <div className="absolute top-2 right-2 flex items-center gap-2 bg-card/70 dark:bg-card/50 rounded-md p-2">
                    <label className="flex items-center gap-2 text-sm"><span>Landmarks</span><Switch checked={overlayLandmarks} onChange={(v) => setOverlayLandmarks(typeof v === 'boolean' ? v : overlayLandmarks)} /></label>
                    <label className="flex items-center gap-2 text-sm"><span>Plumb</span><Switch checked={overlayPlumb} onChange={(v) => setOverlayPlumb(typeof v === 'boolean' ? v : overlayPlumb)} /></label>
                  </div>
                )}
              </div>
              <div className="flex gap-2 mt-4">
                <Button className="h-12 w-full" onClick={handleCapture}>
                  {Icon("Camera", { className: "h-4 w-4 mr-2" })}
                  Capture
                </Button>
                {images[activeView] && (
                  <Button className="h-12" variant="destructive" onClick={handleDeleteView}>
                    {Icon("Trash", { className: "h-4 w-4 mr-2" })}
                    Delete
                  </Button>
                )}
              </div>
            </div>
          </Card>

          {/* Unassigned images */}
          {unassigned.length > 0 && (
            <Card className="mt-2">
              <div className="p-4">
                <h4 className="font-semibold mb-3">Unassigned Images</h4>
                <div className="grid grid-cols-3 gap-2">
                  {unassigned.map((u, i) => (
                    <button key={i} onClick={() => {
                      setImages((prev) => ({ ...prev, [activeView]: u }));
                      setUnassigned((arr) => arr.filter((_, idx) => idx !== i));
                    }} className="w-full aspect-square overflow-hidden rounded-md border border-border">
                      <img src={u} alt="thumb" className="w-full h-full object-cover" />
                    </button>
                  ))}
                </div>
              </div>
            </Card>
          )}
        </div>

        {/* Right: Analysis Panels */}
        <div className="flex flex-col gap-4">
          <Card>
            <div className="p-4 border-b border-border dark:border-border">
              <h4 className="font-semibold">{activeView} View Analysis</h4>
              <p className="text-sm text-muted-foreground">Real-time biomechanical measurements</p>
            </div>
            <div className="p-4">
              <table className="w-full text-sm">
                <thead className="text-left text-muted-foreground">
                  <tr>
                    <th className="py-2">Metric</th>
                    <th className="py-2">Value</th>
                    <th className="py-2">Severity</th>
                  </tr>
                </thead>
                <tbody>
                  {[{ m: "Head Tilt", v: "4°", s: "Low" }, { m: "Shoulder Asymmetry", v: "12 mm", s: "Moderate" }, { m: "Pelvic Shift", v: "8 mm", s: "High" }].map((r, i) => (
                    <tr key={i} className="border-t border-border dark:border-border">
                      <td className="py-2">{r.m}</td>
                      <td className="py-2">{r.v}</td>
                      <td className="py-2">
                        <Badge className={
                          r.s === "Low" ? "bg-success-surface text-success-text" : r.s === "Moderate" ? "bg-warning-surface text-warning-text" : "bg-error-surface text-error-text"
                        }>{r.s}</Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>

          <Card>
            <div className="p-4 border-b border-border dark:border-border"><h4 className="font-semibold">3D Model</h4></div>
            <div className="p-4">
              <div className="w-full aspect-video bg-background dark:bg-card rounded-md grid place-items-center text-muted-foreground">3D canvas here</div>
              <div className="flex gap-2 mt-3">
                <Button variant="outline">Rotate Left</Button>
                <Button variant="outline">Rotate Right</Button>
              </div>
            </div>
          </Card>
        </div>
      </div>

      {/* Sticky Toolbar */}
      <div className="sticky bottom-4 z-30">
        <div className="ml-auto w-fit bg-card/90 dark:bg-card/70 border border-border dark:border-border backdrop-blur rounded-full shadow-sm px-2 py-1 flex items-center gap-1">
          <Button className="h-10" onClick={handleSave} disabled={saving !== "idle"}>
            {Icon("Save", { className: "h-4 w-4 mr-2" })}
            {saving === "saving" ? "Saving…" : saving === "saved" ? "Saved" : "Save"}
          </Button>
          <Divider className="mx-1 w-px h-6" />
          <Button className="h-10" variant="outline" onClick={() => alert("Export PDF")}>{Icon("Download", { className: "h-4 w-4 mr-2" })}Export</Button>
          <Button className="h-10" variant="outline" onClick={() => setShowResetConfirm(true)}>{Icon("RotateCcw", { className: "h-4 w-4 mr-2" })}Reset</Button>
        </div>
      </div>

      {/* Client Picker Dialog */}
      {showClientDialog && (
        <Dialog onClose={() => setShowClientDialog(false)}>
          <Card className="max-w-lg w-full">
            <div className="p-6 text-center">
              <div className="mx-auto bg-primary/10 p-3 rounded-full w-fit mb-4">{Icon("FileScan", { className: "h-8 w-8 text-primary" })}</div>
              <h3 className="text-2xl font-bold">Select a Client</h3>
              <p className="text-muted-foreground mt-2">Choose which client you're assessing</p>
              <div className="mt-4">
                <ClientSelector onPick={(c) => { onPickClient(c); setShowClientDialog(false); }} />
                <Button variant="outline" className="w-full h-12 mt-3" onClick={() => alert("Create new client")}>{Icon("UserPlus", { className: "h-4 w-4 mr-2" })}Create New Client</Button>
              </div>
            </div>
          </Card>
        </Dialog>
      )}

      {/* Reset Confirm */}
      {showResetConfirm && (
        <AlertDialog title="Reset Analysis?" description="This will delete all captured images and analysis data. This action cannot be undone." onCancel={() => setShowResetConfirm(false)} onConfirm={() => { setShowResetConfirm(false); handleReset(); }} confirmLabel="Reset" />
      )}
    </div>
  );
};

// =============================
// SOP ASSESSMENT (/sop-assessment)
// =============================
const SOPAssessment: React.FC<{
  client: { id: string; name: string } | null;
  onPickClient: (c: any) => void;
}> = ({ client, onPickClient }) => {
  const [current, setCurrent] = useState(client);
  const [showPicker, setShowPicker] = useState(!client);
  const [showReset, setShowReset] = useState(false);

  // Test grid state (simplified)
  type Row = { key: string; name: string; L?: number | ""; R?: number | "" };
  const [rows, setRows] = useState<Row[]>([
    { key: "shoulderIR", name: "Shoulder Internal Rotation", L: "", R: "" },
    { key: "slr", name: "Straight Leg Raise", L: "", R: "" },
    { key: "hipExtension", name: "Hip Extension", L: "", R: "" },
    { key: "abd", name: "Shoulder Abduction", L: "", R: "" },
    { key: "hipabd", name: "Hip Abduction", L: "", R: "" },
    { key: "cervrot", name: "Cervical Rotation", L: "", R: "" },
    { key: "cervlat", name: "Cervical Lateral Flexion", L: "", R: "" },
    { key: "pelrot", name: "Pelvis Rotation", L: "", R: "" },
    { key: "ground", name: "Grounding Performance", L: "", R: "" },
  ]);

  const handleChange = (idx: number, side: "L" | "R", val: string) => {
    setRows((r) => r.map((row, i) => (i === idx ? { ...row, [side]: val === "" ? "" : Number(val) } : row)));
  };

  const results = useMemo(() => {
    // Minimal mock logic – replace with your classification engine
    const rIR = rows.find((r) => r.key === "shoulderIR");
    const pattern = (Number(rIR?.L || 0) < 50 || Number(rIR?.R || 0) < 50) ? "Phase 1 Candidate" : "Phase 2+ Ready";
    return {
      pattern: Number(rIR?.R || 0) < Number(rIR?.L || 0) ? "Right Lateralization (working theory)" : "Anterior Orientation (working theory)",
      keyFindings: [
        { label: "Shoulder IR threshold", severity: (Number(rIR?.L || 0) < 50 || Number(rIR?.R || 0) < 50) ? "High" as const : "Low" as const },
      ],
      recommendations: [
        "Initiate Phase 1 restoration focusing on posterior expansion and stacking",
        "Prioritize asymmetrical work to address lateralization cues",
      ],
      phase: pattern,
    };
  }, [rows]);

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col gap-2 mb-2">
        <div className="flex items-start justify-between">
          <h2 className="text-3xl font-bold tracking-tight">SOP Assessment</h2>
          <Button variant="ghost" onClick={() => setShowPicker(true)}>{current ? current.name : "Select Client"}</Button>
        </div>
        <p className="text-muted-foreground">{current ? `For ${current.name}` : "Analyze movement patterns and biomechanical assessments to identify postural compensations."}</p>
      </div>

      {/* Client info card */}
      {current && (
        <Card className="mb-4"><div className="p-4 flex items-center justify-between gap-4">
          <label className="text-sm font-medium">Client Name</label>
          <Input defaultValue={current.name} className="max-w-xs" />
          <Button variant="outline" className="h-10" onClick={() => setShowPicker(true)}>Change Client</Button>
        </div></Card>
      )}

      {/* Movement tests */}
      <Card>
        <div className="p-4 border-b border-border dark:border-border">
          <h4 className="font-semibold">Movement Tests</h4>
          <p className="text-sm text-muted-foreground">Enter measurements and test results</p>
        </div>
        <div className="p-4 overflow-x-auto touch-pan-xy">
          <table className="w-full text-sm">
            <thead className="text-left text-muted-foreground">
              <tr>
                <th className="w-1/3 py-2">Test Name</th>
                <th className="w-1/3 py-2">Left (L)</th>
                <th className="w-1/3 py-2">Right (R)</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr key={row.key} className="border-t border-border dark:border-border">
                  <td className="py-2 font-medium text-sm">{row.name}</td>
                  <td className="py-2 pr-2">
                    <div className="relative">
                      <Input type="number" inputMode="numeric" placeholder="°" value={row.L as any} onChange={(e) => handleChange(idx, "L", e.target.value)} className="h-10 text-center" />
                      <button aria-label="Open Visual Goniometer for Left" className="absolute top-1 right-1 h-8 w-8 grid place-items-center rounded-md hover:bg-background dark:hover:bg-card" onClick={() => alert(`Open VisioMeter for ${row.name} (L)`) }>
                        {Icon("Camera", { className: "h-4 w-4" })}
                      </button>
                    </div>
                  </td>
                  <td className="py-2">
                    <div className="relative">
                      <Input type="number" inputMode="numeric" placeholder="°" value={row.R as any} onChange={(e) => handleChange(idx, "R", e.target.value)} className="h-10 text-center" />
                      <button aria-label="Open Visual Goniometer for Right" className="absolute top-1 right-1 h-8 w-8 grid place-items-center rounded-md hover:bg-background dark:hover:bg-card" onClick={() => alert(`Open VisioMeter for ${row.name} (R)`) }>
                        {Icon("Camera", { className: "h-4 w-4" })}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Analysis Results */}
      <Card className="mt-6">
        <div className="p-4 border-b border-border dark:border-border">
          <h4 className="font-semibold">Analysis Results</h4>
          <p className="text-sm text-muted-foreground">Automated interpretation based on test results</p>
        </div>
        <div className="p-4 space-y-4">
          <section className="p-4 bg-background/50 dark:bg-card/40 rounded-md">
            <h5 className="font-semibold">Movement Pattern</h5>
            <p className="text-sm mt-1">{results.pattern}</p>
          </section>
          <section>
            <h5 className="font-semibold">Key Findings</h5>
            <ul className="mt-2 space-y-2">
              {results.keyFindings.map((k, i) => (
                <li key={i} className="flex items-center gap-2 text-sm">
                  <Badge className={k.severity === "High" ? "bg-error-surface text-error-text" : "bg-success-surface text-success-text"}>{k.severity}</Badge>
                  <span>{k.label}</span>
                </li>
              ))}
            </ul>
          </section>
          <section>
            <h5 className="font-semibold">Recommendations</h5>
            <ul className="mt-2 list-disc pl-5 text-sm space-y-1">
              {results.recommendations.map((r, i) => (<li key={i}>{r}</li>))}
            </ul>
          </section>
          <section className="p-4 border-l-4 border-primary">
            <h5 className="font-semibold">Progression Model Phase</h5>
            <p className="text-sm mt-1">{results.phase}</p>
          </section>
        </div>
      </Card>

      {/* Sticky Toolbar */}
      <div className="sticky bottom-4 z-30">
        <div className="ml-auto w-fit bg-card/90 dark:bg-card/70 border border-border dark:border-border backdrop-blur rounded-full shadow-sm px-2 py-1 flex items-center gap-1">
          <Button className="h-10" onClick={() => alert("Save Assessment")}>{Icon("Save", { className: "h-4 w-4 mr-2" })}Save</Button>
          <Divider className="mx-1 w-px h-6" />
          <Button className="h-10" variant="outline" onClick={() => alert("Export Assessment PDF")}>{Icon("Download", { className: "h-4 w-4 mr-2" })}Export</Button>
          <Button className="h-10" variant="outline" onClick={() => setShowReset(true)}>{Icon("RotateCcw", { className: "h-4 w-4 mr-2" })}Reset</Button>
        </div>
      </div>

      {showPicker && (
        <Dialog onClose={() => setShowPicker(false)}>
          <Card className="max-w-lg w-full">
            <div className="p-6">
              <h3 className="text-xl font-semibold">Select Client</h3>
              <div className="mt-3"><ClientSelector onPick={(c) => { setCurrent(c); onPickClient(c); setShowPicker(false); }} /></div>
              <div className="mt-4 flex justify-end"><Button variant="outline" onClick={() => setShowPicker(false)}>Close</Button></div>
            </div>
          </Card>
        </Dialog>
      )}

      {showReset && (
        <AlertDialog title="Reset Assessment?" description="This will clear all test results and analysis. This action cannot be undone." onCancel={() => setShowReset(false)} onConfirm={() => { setRows((r) => r.map((x) => ({ ...x, L: "", R: "" }))); setShowReset(false); }} confirmLabel="Reset" />
      )}
    </div>
  );
};

// =============================
// DRILL LIBRARY (/drills)
// =============================

type Drill = {
  id: string;
  title: string;
  description: string;
  category: string;
  difficulty: "Beginner" | "Intermediate" | "Advanced";
  equipment: string[];
  views: number;
  video?: string; // youtube url
};

const mockDrills: Drill[] = Array.from({ length: 9 }).map((_, i) => ({
  id: `d-${i + 1}`,
  title: `Drill ${i + 1}: Left Sidelying Adductor Pullback`,
  description: "Build left inner-thigh control. Exhale slow, feel adductor.",
  category: i % 2 ? "Positional" : "Breathing",
  difficulty: (i % 3 === 0 ? "Beginner" : i % 3 === 1 ? "Intermediate" : "Advanced"),
  equipment: ["Wall", ...(i % 2 ? ["Yoga Block"] : [])],
  views: Math.floor(Math.random() * 900 + 100),
  video: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
}));

const DrillLibrary: React.FC = () => {
  const [query, setQuery] = useState("");
  const [filtersOpen, setFiltersOpen] = useState(true);
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const [viewMode, setViewMode] = useState<"grid" | "list">("grid");
  const [drills, setDrills] = useState<Drill[]>(mockDrills);
  const [formOpen, setFormOpen] = useState(false);
  const [bulkOpen, setBulkOpen] = useState(false);
  const [importOpen, setImportOpen] = useState(false);

  const filtered = useMemo(() => drills.filter(d => d.title.toLowerCase().includes(query.toLowerCase())), [drills, query]);
  const toggleSelect = (id: string) => setSelected(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-start">
        <div>
          <h2 className="text-3xl font-bold tracking-tight">Drill Library</h2>
          <p className="text-muted-foreground">Comprehensive exercise library</p>
        </div>
        <div className="hidden md:flex items-center gap-2">
          <Button variant={viewMode === "grid" ? "ghost" : "ghost"} className={`${viewMode === "grid" ? "bg-background dark:bg-card" : ""} h-10 w-10`} onClick={() => setViewMode("grid")} title="Grid view">▦</Button>
          <Button variant={viewMode === "list" ? "ghost" : "ghost"} className={`${viewMode === "list" ? "bg-background dark:bg-card" : ""} h-10 w-10`} onClick={() => setViewMode("list")} title="List view">≣</Button>
        </div>
      </div>

      {/* Search + Filters */}
      <Card className="p-4">
        <div className="flex flex-col gap-4">
          <div className="flex gap-2">
            <div className="relative flex-1">
              <Input placeholder="Search drills…" value={query} onChange={(e) => setQuery(e.target.value)} />
              <div className="absolute left-3 top-0 h-12 grid place-items-center text-muted-foreground pointer-events-none">{Icon("Search", { className: "h-5 w-5" })}</div>
            </div>
            <Button variant="outline" className="h-12" onClick={() => setFiltersOpen((v) => !v)}>
              {Icon("Filter", { className: "h-4 w-4 mr-2" })}Filters
            </Button>
          </div>

          {filtersOpen && (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
              {/* Category */}
              <div>
                <label className="text-sm font-medium">Category</label>
                <select className="h-12 w-full rounded-md border border-border dark:border-border bg-card dark:bg-card mt-1">
                  <option>All</option>
                  <option>Positional</option>
                  <option>Breathing</option>
                  <option>Mobility</option>
                </select>
              </div>
              {/* Difficulty */}
              <div>
                <label className="text-sm font-medium">Difficulty</label>
                <select className="h-12 w-full rounded-md border border-border dark:border-border bg-card dark:bg-card mt-1">
                  <option>All</option>
                  <option>Beginner</option>
                  <option>Intermediate</option>
                  <option>Advanced</option>
                </select>
              </div>
              {/* Equipment */}
              <div>
                <label className="text-sm font-medium">Equipment</label>
                <select className="h-12 w-full rounded-md border border-border dark:border-border bg-card dark:bg-card mt-1">
                  <option>Any</option>
                  <option>Wall</option>
                  <option>Ball</option>
                  <option>Yoga Block</option>
                </select>
              </div>
              {/* Sort */}
              <div>
                <label className="text-sm font-medium">Sort By</label>
                <select className="h-12 w-full rounded-md border border-border dark:border-border bg-card dark:bg-card mt-1">
                  <option>Name (A-Z)</option>
                  <option>Name (Z-A)</option>
                  <option>Date Added (Newest)</option>
                  <option>Date Added (Oldest)</option>
                </select>
              </div>
            </div>
          )}

          {/* Active filters (mock) */}
          <div className="flex flex-wrap gap-2 mt-1">
            <Badge className="bg-primary/10 text-primary hover:bg-primary/20">Positional ✕</Badge>
            <button className="text-sm text-muted-foreground underline">Clear All</button>
          </div>
        </div>
      </Card>

      {/* Inline Drill Form */}
      {formOpen && (<DrillForm onClose={() => setFormOpen(false)} onSave={(d) => { setDrills((arr) => [d, ...arr]); setFormOpen(false); }} />)}

      {/* Bulk Tag Editor */}
      {bulkOpen && (<BulkTagEditor count={selected.size} onClose={() => setBulkOpen(false)} />)}

      {/* Grid/List */}
      {filtered.length === 0 ? (
        <Card className="max-w-lg mx-auto text-center p-8">
          <div className="mx-auto h-12 w-12 text-muted-foreground">{Icon("Dumbbell", { className: "h-12 w-12" })}</div>
          <h4 className="text-lg font-semibold mt-2">No Drills Found</h4>
          <p className="text-muted-foreground">Try adjusting your filters or add your first drill.</p>
          <Button className="h-12 mt-3" onClick={() => setFormOpen(true)}>{Icon("Plus", { className: "h-4 w-4 mr-2" })}Add Drill</Button>
        </Card>
      ) : (
        <div className={`grid ${viewMode === "grid" ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3" : "grid-cols-1"} gap-4`}>
          {filtered.map((d) => (<DrillCard key={d.id} drill={d} selected={selected.has(d.id)} onToggle={() => toggleSelect(d.id)} />))}
        </div>
      )}

      {/* Contextual Toolbar */}
      <div className="sticky bottom-4 z-30">
        <div className="ml-auto w-fit bg-card/90 dark:bg-card/70 border border-border dark:border-border backdrop-blur rounded-full shadow-sm px-2 py-1 flex items-center gap-1">
          <Button className="h-10" onClick={() => setFormOpen(true)}>{Icon("Plus", { className: "h-4 w-4 mr-2" })}New Drill</Button>
          {selected.size > 0 && (<>
            <Divider className="mx-1 w-px h-6" />
            <Button className="h-10" variant="outline" onClick={() => setBulkOpen(true)}>Edit Tags <Badge className="ml-2 bg-background text-foreground">{selected.size}</Badge></Button>
            <Button className="h-10" variant="destructive" onClick={() => alert(`Delete ${selected.size} drills (confirm modal here)`) }>{Icon("Trash", { className: "h-4 w-4 mr-2" })}Delete <Badge className="ml-2 bg-card/20">{selected.size}</Badge></Button>
          </>)}
          <Divider className="mx-1 w-px h-6" />
          <Button className="h-10" variant="outline" onClick={() => setImportOpen(true)}>{Icon("Upload", { className: "h-4 w-4 mr-2" })}Import</Button>
          <Button className="h-10" variant="outline" onClick={() => alert("Export CSV")}>{Icon("Download", { className: "h-4 w-4 mr-2" })}Export</Button>
          <Button className="h-10" variant="ghost">{Icon("CheckSquare", { className: "h-4 w-4 mr-2" })}Select</Button>
        </div>
      </div>

      {importOpen && (
        <Dialog onClose={() => setImportOpen(false)}>
          <Card className="max-w-2xl w-full">
            <div className="p-6">
              <h3 className="text-xl font-semibold">Import Drills from CSV</h3>
              <p className="text-sm text-muted-foreground">Drag and drop a CSV or use the file picker.</p>
              <div className="mt-4 border-2 border-dashed rounded-md p-8 text-center">Drop file here</div>
              <div className="mt-4 flex justify-end gap-2"><Button variant="outline" onClick={() => setImportOpen(false)}>Cancel</Button><Button>Import</Button></div>
            </div>
          </Card>
        </Dialog>
      )}
    </div>
  );
};

const DrillCard: React.FC<{ drill: Drill; selected: boolean; onToggle: () => void }> = ({ drill, selected, onToggle }) => {
  return (
    <Card className="relative hover:shadow-md transition">
      {/* Selection checkbox */}
      <label className="absolute top-2 left-2 inline-flex items-center gap-2 z-10">
        <input type="checkbox" checked={selected} onChange={onToggle} className="h-5 w-5" />
      </label>
      <div className="p-4">
        <div className="w-full aspect-video rounded-md bg-background dark:bg-card grid place-items-center relative overflow-hidden">
          {drill.video ? (
            <button onClick={() => alert("Open video modal") } className="absolute inset-0 grid place-items-center text-3xl">▶</button>
          ) : (
            <span className="text-muted-foreground">No video</span>
          )}
        </div>
      </div>
      <div className="px-4 pb-2">
        <div className="font-semibold text-base line-clamp-2">{drill.title}</div>
        <p className="text-sm text-muted-foreground line-clamp-2 mt-1">{drill.description}</p>
      </div>
      <div className="flex flex-wrap gap-1 px-4 pb-2">
        <Badge className="bg-primary/20 text-primary text-xs rounded-full px-2 py-0.5 border-none">{drill.category}</Badge>
        <Badge className="bg-background text-foreground text-xs rounded-full px-2 py-0.5">{drill.difficulty}</Badge>
        {drill.equipment.map((e, i) => (
          <span key={i} className="text-xs text-muted-foreground">• {e}</span>
        ))}
      </div>
      <div className="flex items-center justify-between px-4 pb-4">
        <span className="text-xs text-muted-foreground">{drill.views} views</span>
        <div className="relative">
          <Button variant="ghost" className="h-8 w-8 p-0" onClick={() => alert("Open actions") }>{Icon("MoreHorizontal", { className: "h-5 w-5" })}</Button>
        </div>
      </div>
    </Card>
  );
};

const DrillForm: React.FC<{ onClose: () => void; onSave: (d: Drill) => void }> = ({ onClose, onSave }) => {
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [url, setUrl] = useState("");
  const [category, setCategory] = useState("");
  const [difficulty, setDifficulty] = useState<Drill["difficulty"]>("Beginner");
  const [equipment, setEquipment] = useState<string[]>([]);
  const [saving, setSaving] = useState(false);

  const save = () => {
    if (!title.trim() || !category) return alert("Name and Category are required");
    setSaving(true);
    const d: Drill = {
      id: crypto.randomUUID(),
      title, description: desc, video: url, category, difficulty, equipment, views: 0,
    };
    setTimeout(() => onSave(d), 400);
  };

  return (
    <Card className="border-2 border-primary shadow-lg rounded-lg">
      <div className="p-4 border-b flex items-center justify-between">
        <h4 className="text-xl font-semibold">Add New Drill</h4>
        <Button variant="ghost" className="h-8 w-8" onClick={onClose}>✕</Button>
      </div>
      <div className="p-6 space-y-4">
        <div>
          <label className="text-sm font-medium">Drill Name *</label>
          <Input placeholder="Enter drill name" value={title} onChange={(e) => setTitle(e.target.value)} />
        </div>
        <div>
          <label className="text-sm font-medium">Description</label>
          <Textarea placeholder="Describe the drill…" value={desc} onChange={(e) => setDesc(e.target.value)} className="min-h-24" />
          <div className="text-xs text-muted-foreground mt-1">{desc.length} chars</div>
        </div>
        <div>
          <label className="text-sm font-medium">YouTube URL</label>
          <Input placeholder="https://youtube.com/watch?v=…" value={url} onChange={(e) => setUrl(e.target.value)} />
          {/^https?:\/\/(www\.)?youtu/i.test(url) && (
            <div className="mt-2"><div className="w-full aspect-video bg-background rounded-md grid place-items-center">Thumbnail preview</div></div>
          )}
        </div>
        <div>
          <label className="text-sm font-medium">Category *</label>
          <select value={category} onChange={(e) => setCategory(e.target.value)} className="h-12 w-full rounded-md border border-border dark:border-border bg-card dark:bg-card">
            <option value="">Select…</option>
            <option>Positional</option>
            <option>Breathing</option>
            <option>Mobility</option>
          </select>
        </div>
        <div>
          <label className="text-sm font-medium">Difficulty Level</label>
          <div className="flex gap-2 mt-1">
            {(["Beginner", "Intermediate", "Advanced"] as const).map((d) => (
              <Button key={d} variant={difficulty === d ? "default" : "outline"} className="h-10" onClick={() => setDifficulty(d)}>{d}</Button>
            ))}
          </div>
        </div>
        <div>
          <label className="text-sm font-medium">Required Equipment</label>
          <div className="grid grid-cols-2 gap-2 mt-1">
            {["Wall", "Ball", "Yoga Block", "Bench"].map((eq) => (
              <label key={eq} className="inline-flex items-center gap-2 text-sm">
                <input type="checkbox" checked={equipment.includes(eq)} onChange={(e) => setEquipment((arr) => e.target.checked ? [...arr, eq] : arr.filter((x) => x !== eq))} />
                {eq}
              </label>
            ))}
          </div>
        </div>
        <div>
          <label className="text-sm font-medium">Tags</label>
          <Input placeholder="Comma-separated (e.g., Phase1, Left-Stack)" />
        </div>
      </div>
      <div className="p-4 border-t bg-background/60 dark:bg-card/40 flex items-center justify-between">
        <Button variant="ghost" className="text-error-text">Delete</Button>
        <div className="flex gap-2">
          <Button variant="outline" className="h-12" onClick={onClose}>Cancel</Button>
          <Button className="h-12" onClick={save} disabled={saving}>{saving ? "Saving…" : "Save Drill"}</Button>
        </div>
      </div>
    </Card>
  );
};

const BulkTagEditor: React.FC<{ count: number; onClose: () => void }> = ({ count, onClose }) => (
  <Card className="border-2 border-primary shadow-lg rounded-lg">
    <div className="p-4 border-b flex items-center justify-between">
      <h4 className="text-xl font-semibold">Bulk Edit Tags – {count} drills selected</h4>
      <Button variant="ghost" className="h-8 w-8" onClick={onClose}>✕</Button>
    </div>
    <div className="p-6 space-y-6">
      <div>
        <label className="text-sm font-medium">Current Tags Across Selection</label>
        <div className="flex flex-wrap gap-2 mt-2">
          {["Phase1", "Left", "Breathing"].map((t) => (
            <Badge key={t} className="bg-background text-foreground">{t}<span className="ml-1 text-xs">×3</span></Badge>
          ))}
        </div>
      </div>
      <div>
        <label className="text-sm font-medium">Add Tags to All Selected</label>
        <Input placeholder="Type to add…" />
        <Button className="mt-2">Add</Button>
      </div>
      <div>
        <label className="text-sm font-medium">Remove Tags from All Selected</label>
        <Input placeholder="Type to remove…" />
        <Button className="mt-2" variant="outline">Remove</Button>
      </div>
      <div>
        <label className="text-sm font-medium">Replace All Tags</label>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          <Input placeholder="From…" />
          <Input placeholder="To…" />
        </div>
        <Button className="mt-2" variant="outline">Replace</Button>
      </div>
      <div>
        <label className="text-sm font-medium">Preview Changes</label>
        <ul className="mt-2 max-h-40 overflow-auto text-sm list-disc pl-5">
          {Array.from({ length: 6 }).map((_, i) => (<li key={i}>Drill {i + 1} – Phase1 → Phase2</li>))}
        </ul>
      </div>
    </div>
    <div className="p-4 border-t flex justify-end gap-2">
      <Button variant="outline" onClick={onClose}>Cancel</Button>
      <Button>Apply Changes</Button>
    </div>
  </Card>
);

// =============================
// ASK HARRY (/chat)
// =============================
const AskHarry: React.FC = () => {
  return (
    <div className="max-w-4xl p-2">
      <div className="flex flex-col gap-2 mb-8">
        <h2 className="text-3xl font-bold tracking-tight">Ask Harry</h2>
        <p className="text-muted-foreground">Ask questions and get insights from the course material.</p>
      </div>

      <Card className="shadow-md rounded-lg max-w-xl">
        <div className="p-6 flex items-center gap-4">
          <div className="h-16 w-16 rounded-full border-2 border-primary overflow-hidden bg-background" aria-label="Harry avatar" />
          <div>
            <div className="text-xl font-semibold">Chat with Harry's AI Assistant</div>
            <div className="text-sm text-muted-foreground">Powered by NotebookLM</div>
          </div>
        </div>
        <div className="px-6 pb-6 space-y-4">
          <p className="text-muted-foreground leading-relaxed">Ready to dive deeper? Chat with my AI assistant, trained on all the course materials, to get instant answers to your questions.</p>
          <ul className="text-sm space-y-1">
            <li>✓ Trained on complete biomechanics course</li>
            <li>✓ Instant answers to technical questions</li>
            <li>✓ Drill recommendations and progressions</li>
            <li>✓ Assessment interpretation help</li>
          </ul>
          <a href="https://notebooklm.google.com/notebook/" target="_blank" rel="noreferrer" className="block">
            <Button className="w-full h-12">Open Chat {Icon("ArrowRight", { className: "h-4 w-4 ml-2" })}</Button>
          </a>
          <p className="text-xs text-muted-foreground mt-2">Opens in a new tab. Your conversations are private.</p>
        </div>
      </Card>

      <Card className="shadow-sm rounded-lg mt-6">
        <div className="p-4 border-b"><h4 className="text-lg font-semibold">Need More Help?</h4></div>
        <div className="p-4 space-y-2">
          <Button variant="ghost" className="justify-start w-full">Progression Model guide</Button>
          <Button variant="ghost" className="justify-start w-full">Coaching principles</Button>
          <Button variant="ghost" className="justify-start w-full">Course materials PDF</Button>
        </div>
      </Card>
    </div>
  );
};

// =============================
// Reusable overlays
// =============================
const Dialog: React.FC<{ children: React.ReactNode; onClose: () => void }> = ({ children, onClose }) => (
  <div role="dialog" aria-modal className="fixed inset-0 z-50 grid place-items-center p-4">
    <div className="absolute inset-0 bg-foreground/40" onClick={onClose} />
    <div className="relative z-10 w-full">{children}</div>
  </div>
);

const AlertDialog: React.FC<{
  title: string; description: string; onCancel: () => void; onConfirm: () => void; confirmLabel?: string;
}> = ({ title, description, onCancel, onConfirm, confirmLabel = "Confirm" }) => (
  <Dialog onClose={onCancel}>
    <Card className="max-w-md w-full">
      <div className="p-6">
        <h3 className="text-xl font-semibold">{title}</h3>
        <p className="text-muted-foreground mt-2">{description}</p>
        <div className="mt-6 flex justify-end gap-2">
          <Button variant="outline" className="h-12" onClick={onCancel}>Cancel</Button>
          <Button variant="destructive" className="h-12" onClick={onConfirm}>{confirmLabel}</Button>
        </div>
      </div>
    </Card>
  </Dialog>
);

const ClientSelector: React.FC<{ onPick: (c: { id: string; name: string; heightCm?: number }) => void }> = ({ onPick }) => {
  const [search, setSearch] = useState("");
  const clients = useMemo(() => ([
    { id: "1", name: "James P.", heightCm: 178 },
    { id: "2", name: "Anna G.", heightCm: 165 },
    { id: "3", name: "Lukas T.", heightCm: 183 },
  ]), []);
  const filtered = clients.filter((c) => c.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <Input placeholder="Search clients" value={search} onChange={(e) => setSearch(e.target.value)} />
      <div className="max-h-64 overflow-auto mt-3 divide-y divide-slate-200 dark:divide-slate-800">
        {filtered.map((c) => (
          <button key={c.id} onClick={() => onPick(c)} className="w-full text-left p-3 hover:bg-background dark:hover:bg-card rounded-md">
            <div className="font-medium">{c.name}</div>
            <div className="text-xs text-muted-foreground">Height: {c.heightCm ?? "—"} cm</div>
          </button>
        ))}
      </div>
    </div>
  );
};
